import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MyInvestmentsPageRoutingModule } from './my-investments-routing.module';

import { MyInvestmentsPage } from './my-investments.page';

import { ContractsComponent } from '../components/lists/contracts/contracts.component';
import { BonusesComponent } from '../components/lists/bonuses/bonuses.component';
import { ClientContractsComponent } from '../components/lists/client-contracts/client-contracts.component';
import {SharedComponentsModule} from '../components/shared-components.module';
import {PipesModule} from "../pipes/pipes.modules";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MyInvestmentsPageRoutingModule,
        SharedComponentsModule,
        PipesModule,
    ],
  declarations: [
    MyInvestmentsPage,

  ]
})
export class MyInvestmentsPageModule {}
